import cookieStorage from "../../cookieStorage";

export const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT;

// Reads auth info from cookies at call time so cart/catalog stores never need
// to subscribe to auth store state just to build request headers.
export function getAuthHeaders() {
    const accessToken = cookieStorage.getItem("accessToken");
    if (!accessToken) {
        return {};
    }
    const priceClass = cookieStorage.getItem("priceClass");
    const priceid = cookieStorage.getItem("priceid");
    return {
        token: `Bearer ${accessToken}`,
        priceClass: priceClass ? priceClass : "",
        priceid: priceid ? priceid : null
    };
}

// Module-level caches avoid useState broadcasts on every cache fill
export const productCache = {};
export const orderCache = {};
export const orderIdCache = {};
export const invoiceCache = {};
export const pendingRequests = new Map();
export const customerInflight = new Map();

// Imperative cart actions so list Items can mutate without subscribing to cart state
export const cartActions = {
    mutateCart: null,
    setCartOpen: null
};

export function registerCartActions({ mutateCart, setCartOpen }) {
    cartActions.mutateCart = mutateCart;
    cartActions.setCartOpen = setCartOpen;
}

export function convertIntoNumber(cartSessionTime) {
    const actualReserveTime = 60 * 30;
    const sessionMs = new Date(cartSessionTime).getTime();
    const timeDiff = Math.floor((Date.now() - sessionMs) / 1000);
    return actualReserveTime - timeDiff > 0
        ? actualReserveTime - timeDiff
        : 0;
}
